import SunnyIslesHeroSection from "./components/HeroSection";
import SunnyIslesStickyNav from "./components/StickyNav";
import SunnyIslesProcessingTimeSection from "./components/ProcessingTimeSection";
import SunnyIslesServicesSection from "./components/ServicesSection";
import SunnyIslesLocalAreaSection from "./components/LocalAreaSection";
import SunnyIslesTravelTimingSection from "./components/TravelTimingSection";
import SunnyIslesDestinationsSection from "./components/DestinationsSection";
import SunnyIslesTestimonialsSection from "./components/TestimonialsSection";
import SunnyIslesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SunnyIslesComparisonSection from "./components/ComparisonSection";
import SunnyIslesMistakesSection from "./components/MistakesSection";
import SunnyIslesHowItWorksSection from "./components/HowItWorksSection";
import SunnyIslesFAQSection, { faqs } from "./components/FAQSection";
import SunnyIslesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SunnyIslesFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function SunnyIslesPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Sunny Isles Beach"
        state="Florida"
        stateAbbr="FL"
        route="/sunny-isles"
        title="Emergency Passport Sunny Isles Beach, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Sunny Isles Beach, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Miami-Dade and Broward County travelers."
        geoPlacename="Sunny Isles Beach, Florida"
        geoPosition="25.9254;-80.1215"
        faqs={faqs}
        servicesSchema={servicesList}
      />
      <SunnyIslesHeroSection />
      <SunnyIslesStickyNav />
      <SunnyIslesProcessingTimeSection />
      <SunnyIslesServicesSection />
      <SunnyIslesLocalAreaSection />
      <SunnyIslesTravelTimingSection />
      <SunnyIslesDestinationsSection />
      <SunnyIslesTestimonialsSection />
      <SunnyIslesAcceptanceFacilitiesSection />
      <SunnyIslesComparisonSection />
      <SunnyIslesMistakesSection />
      <SunnyIslesHowItWorksSection />
      <SunnyIslesFAQSection />
      <SunnyIslesHelpfulResourcesSection />
      <SunnyIslesFinalCTA />
    </div>
  );
}